// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navigation_nav__3m1jK","link":"Navigation_link__6sSVh","activeLink":"Navigation_activeLink__KU5Hn","text":"Navigation_text__2VXIo"};